import Image from 'next/image';
import { useRouter } from 'next/router';
import React, { useRef, useState } from 'react';
import { images } from '../../../Constants/ImageUrls';
import { handleUserReviewPopupState } from '../../../CustomHooks/utils';
import { createRippleEffectRelative } from '../../../Utils/helper';
import {
  SeeAllUserImagesButton,
  UserImagesDiv,
  UsersImageCarouselSection,
} from './styled';
import { clicked_card_in_pdp } from './utils';

function UserImagesCustomSection(props) {
  const {
    user_review_images,
    setShowCarouselPopup,
    showCta,
    product,
    index,
    total_count_images,
    parent,
  } = props;
  const count_images = user_review_images?.[0]?.count - 3;
  const firstImage = user_review_images?.[0]?.image;
  const secondImage = user_review_images?.[1]?.image;
  const thirdImage = user_review_images?.[2]?.image;
  const router = useRouter();
  const userImageRef = useRef('');
  const userImageRefNutton = useRef('');

  const total_one_image =
    user_review_images?.[0]?.count === 1 ? 'one_style' : '';
  const total_two_image = user_review_images.length === 2 ? 'two_style' : '';
  const [loaded, setLoaded] = useState(false);
  const onClickOfImage = (e) => {
    if (showCta) {
      e.preventDefault();
      e.stopPropagation();
      clicked_card_in_pdp(e, index, product, total_count_images, parent, true);
      // setTimeout(() => {
      handleUserReviewPopupState(setShowCarouselPopup, router);
      // }, 200);
    }
  };
  return (
    <UsersImageCarouselSection
      thumbDesign={!showCta}
      onClick={(e) => {
        if (showCta) {
          e.preventDefault();
          e.stopPropagation();
        }
      }}
    >
      <UserImagesDiv
        id="user_div"
        thumbDesign={!showCta}
        ref={userImageRef}
        onClick={(e) => {
          createRippleEffectRelative(e, userImageRef.current);
          onClickOfImage(e);
        }}
      >
        <div className={`left_side ${total_one_image} ${total_two_image}`}>
          <Image
            src={firstImage}
            alt={product?.name}
            fill
            sizes={showCta ? '30vw' : '5vw'}
          />
        </div>
        <div className="right_side">
          <div className={total_two_image ? total_two_image : `first_div`}>
            {secondImage ? (
              <Image
                src={secondImage}
                alt={product?.name}
                fill
                sizes={showCta ? '15vw' : '5vw'}
              />
            ) : null}

            {/* <img src={secondImage} /> */}
          </div>
          <div className="second_div">
            {thirdImage ? (
              <Image
                src={thirdImage}
                alt={product?.name}
                onLoad={() => {
                  setLoaded(true);
                }}
                fill
                sizes={showCta ? '15vw' : '5vw'}
              />
            ) : null}
            {count_images > 0 && showCta && loaded ? (
              <div className="more">{`+ ${count_images} more`}</div>
            ) : null}
            {/* <img src={thirdImage} /> */}
          </div>
        </div>
      </UserImagesDiv>
      {showCta && (
        <SeeAllUserImagesButton
          id="user_images_button"
          ref={userImageRefNutton}
          onClick={(e) => {
            createRippleEffectRelative(e, userImageRefNutton.current, 'black');
            onClickOfImage(e);
          }}
        >
          See All User Photos <img src={images.arrow_verm} alt={'verm_arrow'} />
        </SeeAllUserImagesButton>
      )}
    </UsersImageCarouselSection>
  );
}

export default UserImagesCustomSection;
